import { deviceModels } from "./deviceModels";

export const deviceVersionPatch = {
  [deviceModels.MERCURY_W_LCD_C]: "1",
  [deviceModels.MERCURY_W_LB_C]: "2",
  [deviceModels.MERCURY_L_LCD_C]: "3",
  [deviceModels.MERCURY_L_LB_C]: "4"
};
